// MUI requires an array of exactly 25 shadow strings (index 0 = "none").
// We generate a soft, layered ramp. Light mode uses subtle grey shadows;
// dark mode uses deeper, lower-opacity shadows so elevation still reads
// against the elevated-grey surfaces.

const buildShadows = (color) => {
  const ELEV = [
    "none",
    `0 1px 2px 0 ${color(0.08)}`,
    `0 2px 4px -1px ${color(0.1)}`,
    `0 3px 6px -2px ${color(0.1)}`,
    `0 4px 8px -2px ${color(0.12)}`,
    `0 5px 10px -3px ${color(0.12)}`,
    `0 6px 12px -3px ${color(0.14)}`,
    `0 7px 14px -4px ${color(0.14)}`,
    `0 8px 16px -4px ${color(0.16)}`,
    `0 9px 18px -5px ${color(0.16)}`,
    `0 10px 20px -5px ${color(0.18)}`,
    `0 11px 22px -5px ${color(0.18)}`,
    `0 12px 24px -6px ${color(0.2)}`,
    `0 13px 26px -6px ${color(0.2)}`,
    `0 14px 28px -7px ${color(0.22)}`,
    `0 15px 30px -7px ${color(0.22)}`,
    `0 16px 32px -8px ${color(0.24)}`,
    `0 17px 34px -8px ${color(0.24)}`,
    `0 18px 36px -9px ${color(0.26)}`,
    `0 19px 38px -9px ${color(0.26)}`,
    `0 20px 40px -10px ${color(0.28)}`,
    `0 21px 42px -10px ${color(0.28)}`,
    `0 22px 44px -11px ${color(0.3)}`,
    `0 23px 46px -11px ${color(0.3)}`,
    `0 24px 48px -12px ${color(0.32)}`,
  ];
  return ELEV;
};

/**
 * @param {"light"|"dark"} mode
 * @returns {string[]} 25 shadow definitions
 */
export const getShadows = (mode) =>
  mode === "dark"
    ? buildShadows((a) => `rgba(0, 0, 0, ${a + 0.1})`)
    : buildShadows((a) => `rgba(47, 43, 61, ${a})`);

export default getShadows;
